<template>
    <div>
        <b-modal v-model="setting.isShow" size="lg" scrollable @hidden="close()" >
           <template #modal-title>
                <h2>รายชื่อร้านค้า</h2>
            </template>
            <h4 v-for="(shop, key) in setting.listShop" :key="`${key}-${shop}`">
                {{ convertKeyToText(key) }}
                <template v-if="shop.length > 0">
                    <ol>
                        <li v-for="detail, i in shop" :key="i">
                            {{ convertDetailToText(detail) }}
                        </li>
                    </ol>
                </template>
                <template v-else>
                    <ul>
                        <li> ไม่พบข้อมูล {{ convertKeyToText(key) }}</li>
                    </ul>
                </template>
            </h4>
            <template #modal-footer>
                <b-button
                    :disabled="btnConfirm.disable"
                    variant="primary"
                    size="sm"
                    class="float-right"
                    @click="submit()"
                >
                    {{btnConfirm.text}}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "ShopAvailble",
    props:{
        setting:{
            type: Object,
            default: () => {
                return { 
                    isShow: false,
                    listShop: []
                }
            }
        },
        confirm:{
            type: Function
        },
        close:{
            type: Function
        }
    },
    methods:{
        convertKeyToText( key ){
            if( key === 'available' ) return 'ร้านค้าที่มีในระบบ'
            if( key === 'unavailable' ) return 'ร้านค้าที่ไม่มีในระบบ'
            if( key === 'duplicate' ) return 'ร้านที่มีชื่อซ้ำกัน'
            return 'อื่นๆ'
        },
        convertDetailToText( detail ){
            if( typeof detail === 'object' ) return detail.shop_name
            return detail
        },
        submit(){
            this.confirm( this.setting.listShop.available )
        }
    },
    computed:{
        btnConfirm(){
            let _list = this.setting.listShop
            let res = {
                disable: true,
                text: 'ยืนยัน'
            }
            if( Object.keys(_list).length > 0 && _list.available.length > 0 ){
                res.disable = false
                res.text = `ยืนยันอัพโหลดรายการ ${_list.available.length} ร้านค้า`
            }
            return res
        }
    }
}
</script>